import {
  Container,
  Section,
  MetricCard,
  DashboardChart,
  ActionGroup,
  Grid,
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Stack,
  Text
} from '@tonic/shared/components/ui';
import { PageTitle } from "../../../../components/ui/PageTitle";
import { RecentMovements } from "./RecentMovements";
import {
  Package,
  TrendingUp,
  Truck,
  AlertTriangle,
  Plus,
  FileText,
  ArrowDownToLine,
  Settings
} from "lucide-react";

export function InventoryDashboard() {
  // Mock data for IKEA inventory dashboard
  const categoryData = [
    { name: 'Living Room', value: 35 },
    { name: 'Bedroom', value: 25 },
    { name: 'Kitchen & Dining', value: 20 },
    { name: 'Office', value: 12 },
    { name: 'Outdoor', value: 8 }
  ];

  const statusData = [
    { name: 'In Stock', value: 70 },
    { name: 'Low Stock', value: 18 },
    { name: 'Out of Stock', value: 7 },
    { name: 'On Order', value: 5 }
  ];

  const quickActions = [
    {
      label: 'Add Item',
      icon: Plus,
      onClick: () => console.log('Add item clicked'),
    },
    {
      label: 'Generate Report',
      icon: FileText,
      onClick: () => console.log('Generate report clicked'),
    },
    {
      label: 'Export Data',
      icon: ArrowDownToLine,
      onClick: () => console.log('Export clicked'),
    },
    {
      label: 'Settings',
      icon: Settings,
      onClick: () => console.log('Settings clicked'),
    }
  ];

  return (
    <Container>
      <Section>
        <Stack space={6}>
          <PageTitle
            title="IKEA Inventory Dashboard"
            description="Overview of stock levels and item distribution across IKEA product categories."
            actions={<ActionGroup actions={quickActions} />}
          />

          <Grid cols={1} mdCols={2} lgCols={4} gap={6}>
            <MetricCard
              title="Total Items"
              value="12,458"
              description="Across all departments"
              icon={Package}
              trend={8}
            />
            <MetricCard
              title="Sustainable Items"
              value="4,856"
              description="Eco-friendly products"
              icon={TrendingUp}
              trend={15}
            />
            <MetricCard
              title="Pending Deliveries"
              value="234"
              description="Items in transit"
              icon={Truck}
              trend={3}
            />
            <MetricCard
              title="Low Stock Items"
              value="89"
              description="Below minimum threshold"
              icon={AlertTriangle}
              trend={-12}
              variant="danger"
            />
          </Grid>

          <Grid cols={1} mdCols={2} gap={6}>
            <Card>
              <CardHeader>
                <CardTitle>Stock Distribution by Category</CardTitle>
              </CardHeader>
              <CardContent>
                <DashboardChart
                  title="IKEA Product Categories"
                  type="pie"
                  data={categoryData}
                  dataKey="value"
                  xAxisKey="name"
                  colors={['#0058AB', '#FFDB00', '#66A972', '#E87722', '#4A6372']}
                />
              </CardContent>
            </Card>
            <Card>
              <CardHeader>
                <CardTitle>Items by Status</CardTitle>
              </CardHeader>
              <CardContent>
                <DashboardChart
                  title="Stock Status Distribution"
                  type="pie"
                  data={statusData}
                  dataKey="value"
                  xAxisKey="name"
                  colors={['#66A972', '#FFDB00', '#E87722', '#0058AB']}
                />
              </CardContent>
            </Card>
          </Grid>

          <Grid cols={1} gap={6}>
            <RecentMovements />
          </Grid>
        </Stack>
      </Section>
    </Container>
  );
} 
